import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getWelcomeFirstName, getIsCompanyUser } from './profileHelpers';

export default function DashboardHeader({ title, className = '' }) {
  const { user } = useSelector((state) => state.user);
  const isCompany = getIsCompanyUser(user);
  const welcomeFirstName = getWelcomeFirstName(user, isCompany);
  const heading = title ?? `Welcome back, ${welcomeFirstName}`;

  return (
    <div className={`pr-0 md:pr-[280px] ${className}`.trim()}>
      <h1 className='m-0 font-display text-[38px] font-normal leading-[1.1] tracking-[-0.02em] text-[var(--n900)]'>{heading}</h1>
    </div>
  );
}

DashboardHeader.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};
